import React from "react";
export function SiteFooter() {
  return <footer className="site-footer" data-id="element-180" data-mp="1dqrovx7i9m8c">
      <div className="shell" data-id="element-181" data-mp="3r8j5p2ritcpa">
        <p className="footer-brand" data-id="element-182" data-mp="3r9arjlvbfw2d">
          CUSTOMER SERVICE <span data-id="element-183" data-mp="3mhj8rxieiums">TRAINING READY</span>
        </p>
        <p data-id="element-184" data-mp="3mg85rzws5qwq">Customer Service Training Ready · English-language digital training resources.</p>
        <nav aria-label="Footer navigation" data-id="element-185" data-mp="3hhesa7hhtzwk">
          <a href="#preview" data-id="element-186" data-mp="3hgls5pd1i8ne">Session walkthrough</a>
          <a href="#faq" data-id="element-187" data-mp="3dhw4n3yafaq1">FAQ</a>
          <a href="#offer-details" data-id="element-188" data-mp="3di5yx3qd841j">Offer</a>
        </nav>
        <p className="copyright" data-id="element-189" data-mp="38hi6qeqehh5q">© 2026 Customer Service Training Ready</p>
      </div>
    </footer>;
}